import { RavelElement } from '../../ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';
import { RavelMessages } from '../../../../../modules/RavelMessages.js';

export class RavelAssembly extends RavelElement {
    static get localStyles() {
        return `
        <style>
        #container {
            border: 10px solid #eeeeee;
            border-radius: 12px;
            display: flex;
            flex-direction: column;
            padding: 20px;
            justify-content: center;
            align-items: center;
            max-width: 500px;
            background-color: #ffffff;
            z-index: 10;
        }
        #content {
            display: flex;
            justify-content: space-around;
        }
        #icon {
            font-size: 48px;
        }
        #label {
            font-size: 24px;
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="container">
        <div id="icon">🐼</div>
        <div id="label">foo</div>
        <div id="content">
        <slot></slot>
        </div>
        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 'rows', 'cols', 'show-header', 'border-color'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html
            + this.constructor.baseStyles
            + this.constructor.baseHtml;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.rows = 1;
        this.cols = 1;
        this.icon = '🐼';
        this.label = 'assembly';
        this.showControls = false;   // Assemblies don't generally need signals
        this.showHeader = true;		
        window.addEventListener('load', this.onPageLoaded);
    }
  
    setup = () => {
        this.observedMessages = [`${this.label}`, 'on-page-load'];
        this.subscribe(this.observedMessages);   
        this.shadowRoot.querySelector('#icon').addEventListener('click', this.minimize);
        this.addEventListener(`${this.label}`, this.handleEvents);
        this.shadowRoot.querySelector('#label').innerHTML = `${this.label}`;
        this.shadowRoot.querySelector('#icon').innerHTML = `${this.icon}`;
        if (!this.showHeader) {
            this.shadowRoot.querySelector('#icon').style.display = 'none';
            this.shadowRoot.querySelector('#label').style.display = 'none';
        }
        if (!this.showControls) {
            this.shadowRoot.querySelector('#controls-container').style.display = 'none';
        }
    }
    
    teardown = () => {
       this.unsubscribe(this.observedMessages);
       this.shadowRoot.querySelector('#icon').removeEventListener('click', this.minimize);
    }

    handleEvents = (evt) => {
        if (evt.detail.cmd === 'maximize') {
            this.maximize();
        }
    }

    minimize = () => {
        RavelMessages.sendMessage(`${this.dockTarget}`, 'minimize', this);
        this.shadowRoot.querySelector('#container').style.display = 'none';
    }

    maximize = () => {
        this.shadowRoot.querySelector('#container').style.display = 'flex';
    }

    onPageLoaded = () => {
        console.log('on-page-load-assembly');
        if (this.dockTarget) {
            RavelMessages.sendMessage(`${this.dockTarget}`, 'register', this);
        }
        if (this.docked) this.minimize();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        
        if (name === 'rows') {
            this.rows = parseInt(newValue, 10);
        }
        if (name === 'cols') {
            this.cols = parseInt(newValue, 10);
        }
        if (name === 'show-header') {
            if (newValue === 'false') this.showHeader = false;
        }
        if (name === 'show-controls') {
            if (newValue === 'false') this.showControls = false;
        }
        if (name === 'icon') {
            this.icon = newValue;
            this.shadowRoot.querySelector('#icon').innerHTML = `${this.icon}`;
        }
        if (name === 'label') {
            this.label = newValue;
            this.shadowRoot.querySelector('#label').innerHTML = `${this.label}`;
        }
        if (name === 'border-color') {
            this.shadowRoot.querySelector('#container').style.border = `10px solid ${newValue}`;
        }
        if (name === 'docked') {
            console.log('dock');
            this.docked = true;
        }
    }
}
